import React from 'react';

/**
 * Editor de gramos: input numérico + botones -5/+5.
 * Props:
 *  - mealIndex: number
 *  - category: 'proteina' | 'carbohidrato' | 'grasa' | 'fruta'
 *  - grams: number (valor actual)
 *  - colorClass: string (Tailwind color class for input text)
 *  - onSet(mealIndex, category, newGrams)
 *  - onAdjust(mealIndex, category, delta)
 */
const GramEditor = ({ mealIndex, category, grams, colorClass = 'text-white', onSet, onAdjust }) => (
  <div className="flex items-center gap-1" data-testid={`gram-editor-${category}-${mealIndex}`}>
    <button
      type="button"
      onClick={() => onAdjust(mealIndex, category, -5)}
      className="w-6 h-6 rounded bg-zinc-700 hover:bg-zinc-600 text-white text-sm font-bold"
      aria-label="Reducir 5 gramos"
    >−</button>
    <input
      type="number"
      min="0"
      value={grams}
      onChange={(e) => onSet(mealIndex, category, e.target.value)}
      className={`w-16 bg-zinc-700 border-0 rounded text-center text-sm py-1 ${colorClass}`}
      data-testid={`gram-input-${category}-${mealIndex}`}
    />
    <span className="text-xs text-zinc-400">g</span>
    <button
      type="button"
      onClick={() => onAdjust(mealIndex, category, 5)}
      className="w-6 h-6 rounded bg-zinc-700 hover:bg-zinc-600 text-white text-sm font-bold"
      aria-label="Aumentar 5 gramos"
    >+</button>
  </div>
);

export default GramEditor;
